import Vue from 'vue'
import vueFragment from 'vue-fragment'

Vue.use(vueFragment.Plugin);
Vue.component('fragment', vueFragment.Fragment);
